import { inject, observer } from 'mobx-react'
import MarriedSSI from './MarriedSSI'
import SingleSSI from './SingleSSI'

const SocialSecurityDashboard = function (props) {
  const {
    store: { person },
  } = props

  if (person.maritalStatus && person.includeSpouse) {
    return <MarriedSSI />
  }

  if (!person.maritalStatus || !person.includeSpouse) {
    return <SingleSSI />
  }

  return null
}

export default inject('store', 'main')(observer(SocialSecurityDashboard))
